/*
 * contact-drawer.js — minimal slide-in contact drawer for the icon-bar header.
 * Opened by #contact-icon-open, closed by overlay / close button / Escape.
 * Self-contained: no dependency on the theme's MenuDrawer/SearchModal classes.
 */
if (!customElements.get('contact-drawer')) {
  class ContactDrawer extends HTMLElement {
    constructor() {
      super();
      this.opener = null;
      this.querySelectorAll('[data-contact-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      // Escape closes from anywhere (focus may sit outside this element)
      document.addEventListener('keyup', (event) => {
        if (event.code === 'Escape' && this.classList.contains('active')) this.close();
      });
    }

    connectedCallback() {
      // The header sits inside a sticky-header that applies `transform`, which
      // would make this drawer's position:fixed resolve against the header box
      // (≈header height) instead of the viewport. Relocate to <body> so the
      // overlay + panel fill the whole screen.
      if (this.parentElement && this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
    }

    open(opener) {
      this.opener = opener || null;
      this.classList.add('active');
      document.body.classList.add('contact-drawer-open');
      if (this.opener) this.opener.setAttribute('aria-expanded', 'true');
      // move focus into the drawer once the open transition starts
      const focusTarget = this.querySelector('.contact-drawer__close') || this.querySelector('a');
      if (focusTarget) {
        window.requestAnimationFrame(() => focusTarget.focus());
      }
    }

    close() {
      if (!this.classList.contains('active')) return;
      this.classList.remove('active');
      document.body.classList.remove('contact-drawer-open');
      if (this.opener) {
        this.opener.setAttribute('aria-expanded', 'false');
        this.opener.focus();
        this.opener = null;
      }
    }
  }

  customElements.define('contact-drawer', ContactDrawer);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('#contact-icon-open');
    if (!opener) return;
    event.preventDefault();
    const drawer = document.querySelector('contact-drawer');
    if (drawer) drawer.open(opener);
  });
}
